module.exports = __webpack_public_path__ + "static/media/test.8da09fef.svg";